// extracted by mini-css-extract-plugin
export default {"scroll":"style_scroll__RYzhw"};